export default __webpack_public_path__ + "static/hex-maze-0e609a198a3f1f79307e82cd1109c61e.webp";